<template>
  <div>
    <!-- 自身模块 -->
    <div class="banner self-banner">
      <!-- <div class="banner-title">居民临时身份证识别演示</div>
      <div class="banner-introduce">
        支持多种异形银行卡识别，包括平字、凸字、小卡以及竖卡等，并返回发卡行和卡片类型，可自动对应卡种类号码整体识别，并根据编码规则判断真伪。
      </div> -->
      <div class="banner-content">
        <div class="inner">
          <div class="ocr">
            <div class="left">
              <ocrLeft
                :ocrUrl="ocrUrl"
                :preview_img="preview_img"
                @getOcrResult="getOcrResult"
                :coordinate="coordinate"
                :imgIndex="imgIndex"
                :canvas_rotate="canvas_rotate"
                :ocr_id="reco_id"
              ></ocrLeft>
            </div>
            <div class="right">
              <el-collapse v-model="activeNames" accordion>
                <el-collapse-item name="1">
                  <template slot="title">
                    <div class="title">
                      <img :src="require('../../assets/img/tb.png')" alt="" />
                      <span>识别结果</span>
                    </div>
                  </template>
                  <template v-if="resp_data">
                    <!-- <div class="result-pages">
                      <div class="page-cell">
                        <span class="page-item">表格1</span>
                      </div>
                    </div>
                    <div class="result-content">
                      <div class="result-item">
                        <div class="title"></div>
                        <div class="content"></div>
                      </div>
                    </div> -->
                    <div class="result">
                      <div class="content">
                        <div class="item" @click="resultMouseClick(resp_data.result.name)">
                          <span class="name">姓名</span>
                          <span class="val">{{
                            resp_data.result.name.words
                          }}</span>
                        </div>
                        <div class="item" @click="resultMouseClick(resp_data.result.gender)">
                          <span class="name">性别</span>
                          <span class="val">{{
                            resp_data.result.gender.words
                          }}</span>
                        </div>
                        <div class="item" @click="resultMouseClick(resp_data.result.nationality)">
                          <span class="name">民族</span>
                          <span class="val">{{
                            resp_data.result.nationality.words
                          }}</span>
                        </div>
                        <div class="item" @click="resultMouseClick(resp_data.result.birthdate)">
                          <span class="name">出生</span>
                          <span class="val">{{
                            resp_data.result.birthdate.words
                          }}</span>
                        </div>
                        <div class="item" @click="resultMouseClick(resp_data.result.address)">
                          <span class="name">住址</span>
                          <span class="val">{{
                            resp_data.result.address.words
                          }}</span>
                        </div>
                        <div class="item" @click="resultMouseClick(resp_data.result.idno)">
                          <span class="name">公民身份号码</span>
                          <span class="val">{{
                            resp_data.result.idno.words
                          }}</span>
                        </div>
                        <div class="item" @click="resultMouseClick(resp_data.result.issued)">
                          <span class="name">签发机关</span>
                          <span class="val">{{
                            resp_data.result.issued.words
                          }}</span>
                        </div>
                        <div class="item" @click="resultMouseClick(resp_data.result.valid)">
                          <span class="name">有效期限</span>
                          <span class="val">{{
                            resp_data.result.valid.words
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <ocrNoResult v-else></ocrNoResult>
                </el-collapse-item>
                <el-collapse-item name="2">
                  <template slot="title">
                    <div class="title">
                      <img :src="require('../../assets/img/tb2.png')" alt="" />
                      <span>Response JSON</span>
                    </div>
                  </template>
                  <ocrResult :resp_data="resp_data"></ocrResult>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ocrLeft from "../../components/ocr-left.vue";
import ocrResult from "../../components/ocr-result.vue";
import ocrNoResult from "../../components/ocr-no-result.vue";

import preview_data from "../../../static/preview_data/temp_id_card.js";

export default {
  components: {
    ocrLeft,
    ocrResult,
    ocrNoResult,
  },
  data() {
    return {
      firstKey: 0,
      secondKey: 1,
      activeNames: ["1"],
      tables: [],
      resp_data: "",
      coordinate: [],
      preview_img: [],
      imgIndex: 0, // 当前显示的哪个图片
      canvas_rotate: 0
    };
  },
  computed: {
    ocrUrl() {
      return this.$menuData[1].childs.temp_id_card.ocr_url;
    },
    reco_id(){
      return this.$menuData[1].childs.temp_id_card.reco_id;
    }
  },
  methods: {
    getOcrResult(resp) {
      this.buildViewData(resp);
    },

    resultMouseClick(data) {
      this.coordinate = {
        index: this.imgIndex,
        coordinate: data.quad.split(","),
      };
    },

    buildViewData(result) {
      this.resp_data = result.resp_data;

      if(!result.isMemory){
        this.preview_img.push(result.up_imgBase64);
        this.imgIndex = this.preview_img.length - 1;
      }else{
        this.imgIndex = result.imgIndex;
      }

      this.canvas_rotate = Number(
        result.resp_data.rotation !== undefined ? -result.resp_data.rotation : 0
      );
    }
  },
  mounted() {
    this.buildViewData({
      resp_data: preview_data,
      up_imgBase64: require("../../../static/preview_img/temp_id_card.png"),
      isMemory: false,
      imgIndex: 0,
    });
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/cards/temp_id_card.vue